import { render, staticRenderFns } from "./SelectSpecimens.vue?vue&type=template&id=4a640764"
import script from "./SelectSpecimens.vue?vue&type=script&lang=js"
export * from "./SelectSpecimens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports